export default "__VITE_ASSET__B$aUL6WB__"